<template>
	<div style="width: 100%;">
		<div :class="activeItem == index ? 'join-us-box active' : 'join-us-box'" v-for="(item,index) in hire" :key="index"
		 @click="active(index)">
			<div class="left-title">
				<span class="left-triangle"></span>
				<span class="right-font">聘</span>
				<h2>{{item.position}}</h2>
				<p class="light">招聘人数: {{item.count}}</p>
				<p class="light">工作地点: {{item.base}}</p>
				<h4>岗位职责：</h4>
				<p v-html="item.responsibility">{{item.responsibility}}</p>
				<h4>职位要求：</h4>
				<p v-html="item.requirement">{{item.requirement}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'JoinUs',
		components: {},
		data() {
			return {
				hire: [{
					id: 0,
					position: '云计算大客户销售',
					count: '若干',
					base: '上海市闵行区',
					responsibility: '运用销售工具规划开发新客户，完成公司的销售目标</br>建立与客户间的良好关系，促进业绩的达成</br>协调公司和外部资源，最大程度解决客户问题</br>完成销售岗位及部门领导下发的其他任务',
					requirement: '本科及以上学历，有计算机、互联网相关学历优先</br>对阿里云、AWS、微软云、华为云有了解，1年以上有公有云或私有云销售经验优先或售前支持、技术咨询或项目实施工作经验者优先</br>具有独立拓展销售市场的能力，有电话销售经验者优先</br>有良好的客户服务意识，热爱销售工作，踏实肯干，能独立完成销售项目的规划进展，独立完成客户签约工作，有潜在客户群者优先</br>诚实守信，敬业热情，工作勤奋主动，具有良好的团队合作精神，有强烈的竞争意识，承受较强的工作压力，愿意接受工作挑战'
				}, {
					id: 1,
					position: '高级云计算销售经理',
					count: '若干',
					base: '上海市闵行区',
					responsibility: '销售公司云计算产品及解决方案，完成季度、年度销售目标</br>负责区域市场重点行业客户与合作伙伴的拓展，挖掘市场需求并产生商机</br>收集分析客户需求、业务痛点及竞争对手情况，逐步推动项目进程。配合技术支持人员进行方案演示、产品测试等工作，完成有竞争力的方案</br>建立与客户各决策部门的联系，识别并影响关键决策人</br>负责招投标文件的编写制作、现场竞标及销售方案展示等相关工作</br>负责完成商务谈判与合同签署</br>对项目回款负责，跟踪项目实施情况，协调实施过程中遇到的问题。建立维护良好的客户关系，实现客户高满意度',
					requirement: '大学本科及以上学历，6年以上IT行业从业经验</br>熟悉招投标流程，具有百万级IT项目的运作经验；拥有金融、制造、能源、政务、教育等行业客户资源</br>熟悉云计算技术，云服务领域从业者优先；具有IT行业售前、架构设计和咨询工作经验者优先</br>具有良好的沟通表达能力，较强的客户开发拓展能力。具有较强的抗压能力，适应短期出差</br>优秀的学习能力和自我驱动力，勇于接受挑战，善于开拓创新'
				}, {
					id: 2,
					position: '产品经理',
					count: '若干',
					base: '上海市闵行区',
					responsibility: '负责企业客户混合云管理系统、财务系统、人事系统等平台类产品的设计，并推进落地</br>快速定位客户核心诉求，分析目标用户及用户需求</br>定义并拆解产品目标，设计产品原型，结合需求提供产品解决方案</br>及时对行业相关信息进行收集分析，对平台建设给出优化建议',
					requirement: '负责过ToB业务系统核心模块，可独立完成一个系统的产品闭环</br>强执行力，能基于产品目标及方向快速落地成可执行的产品方案</br>具备一定的产品抽象能力，能够把表象的多种形态客户需求进行归类和抽象</br>思路逻辑清晰，具备优秀的产品设计能力，能迅速洞察需求，挖出客户性质的核心诉求</br>沟通推进能力强，能够快速推进事情落地，具备良好的跨团队多角色沟通</br>本科及以上学历，具备1-3年以上产品设计工作。有混合云管理平台、传统企业服务平台产品经验者优先考虑'
				}, {
					id: 3,
					position: '算法工程师',
					count: '若干',
					base: '嘉兴市南湖区',
					responsibility: '算法框架的搭建，负责路径规划、机器学习，数据分析等算法的研发、前沿技术的研究与攻关</br>人工智能工业化应用领域中，图像识别算法的开发、测试、调优</br>深度学习和生产工艺的结合过程中的算法开发，算法的性能评估及优化</br>负责分析和解决信控算法应用过程中出现的技术问题，负责算法的实现，测试和验证</br>相关技术文档的编写',
					requirement: '本科及以上学历，计算机、数学、统计学、机器学习等相关专业毕业，一流院校或海外名校毕业者优先</br>精通C/C++、Python等编程语言和工具，熟悉TensorFlow、Caffe等架构平台</br>具备深厚的算法设计与实现能力，在机器学习和数据挖掘方面有深入研究者优先</br>图像处理、模式识别及相关研究方向，从事过至少一项该方向的研发项目或开发项目，有实际项目的图像分析算法开发经验的优先考虑'
				}, {
					id: 4,
					position: 'Java开发工程师',
					count: '若干',
					base: '嘉兴市南湖区',
					responsibility: '负责公司业务模块的后端软件设计、开发、维护</br>负责公司业务模块的数据库表设计、开发、升级</br>参与系统架构的代码优化，性能调优</br>参与系统公共库的设计、开发、维护</br>参与产品设计，发现产品设计的优化点</br>协助架构师开展技术研究和新技术调研及应用',
					requirement: '本科以上学历，3-5年以上java项目开发经验</br>熟练掌握Java编程语言</br>熟悉Spring，SpringBoot、MyBatis等相关技术架构</br>熟悉RDBMS，熟悉Mysql或postgres sql数据库</br>熟悉微服务Spring Cloud架构者优先考虑</br>熟悉python脚本语言优先考虑</br>有运维经历者优先考虑</br>快速学习能力和较强的团队协作能力与沟通能力'
				}, {
					id: 5,
					position: '前端开发工程师',
					count: '若干',
					base: '嘉兴市南湖区',
					responsibility: '负责公司产品业务模块的前端页面开发实现</br>参与产品前端组件库的设计、开发、更新、维护优化</br>参与前后端Restful API接口设计</br>参与产品设计，发现产品设计的优化点，提供产品的可用度、易用性</br>参与产品前端代码性能、质量优化</br>协助前端架构师开展技术研究和新技术调研及应用',
					requirement: '本科以上学历，2-3年前端开发经验</br>精通JavaScript、HTML、CSS等前端技术</br>精通Jquery、Vue.js等主流的js框架和库</br>熟悉svg，canvas，使用过d3开发数据可视化项目的优先，熟悉echarts者优先</br>对页面布局具有深刻理解，注重细节，善于分析并改善产品的用户体验</br>快速学习能力和较强的团队协作能力与沟通能力'
				}],
				activeItem: 0,
			}
		},
		methods: {
			active(index) {
				this.activeItem = index;
				console.log(this.activeItem);
				return this.activeItem;
			}
		}
	}
</script>

<style>
	@media(min-width:992px) {
		.join-us-box {
			font-family: "microsoft yahei";
			text-align: left;
			width: 873px;
			min-height: 332px;
			background: rgba(215, 222, 232, .5);
			border: 1px solid rgba(215, 222, 232, 1);
			margin-bottom: 20px;
			position: relative;
			padding-left: 29px;
			/* overflow-y: scroll; */
		}

		.join-us-box.active,
		.join-us-box:hover {
			border-color: rgba(52, 156, 227, 1);
		}

		.join-us-box .left-title span {
			display: inline-block;
		}

		.join-us-box .left-title .left-triangle {
			border-color: transparent RGBA(215, 222, 232, 1);
			border-width: 0px 0px 30px 30px;
			border-style: solid;
			margin-left: -29px;
		}

		.join-us-box.active>.left-title>.left-triangle {
			border-color: transparent rgba(52, 156, 227, 1);
		}

		.join-us-box .left-title .right-font {
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(255, 255, 255, 1);
			position: absolute;
			left: 2px;
			top: 2px;
		}

		.join-us-box h2 {
			font-weight: 500;
			font-size: 18px;
			font-family: MicrosoftYaHei;
			color: rgba(51, 51, 51, 1);
			margin-bottom: 20px;
		}

		.join-us-box h4 {
			font-size: 14px;
			line-height: 24px;
			font-weight: 600;
			margin-top: 20px;
		}

		.join-us-box p {
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(87, 90, 102, 1);
			line-height: 24px;
		}

		.join-us-box p.light {
			color: #848484;
		}
	}

	@media(max-width:992px) {
		.join-us-box {
			font-family: "microsoft yahei";
			text-align: left;
			/* height: 332px; */
			background: rgba(215, 222, 232, .5);
			border: 1px solid rgba(215, 222, 232, 1);
			margin-bottom: 10px;
			position: relative;
			padding: 0 29px;
		}

		.join-us-box.active,
		.join-us-box:hover {
			border-color: rgba(52, 156, 227, 1);
		}

		.join-us-box .left-title span {
			display: inline-block;
		}

		.join-us-box .left-title .left-triangle {
			border-color: transparent RGBA(215, 222, 232, 1);
			border-width: 0px 0px 30px 30px;
			border-style: solid;
			margin-left: -29px;
		}

		.join-us-box.active>.left-title>.left-triangle {
			border-color: transparent rgba(52, 156, 227, 1);
		}

		.join-us-box .left-title .right-font {
			font-size: 12px;
			font-family: MicrosoftYaHei;
			color: rgba(255, 255, 255, 1);
			position: absolute;
			left: 2px;
			top: 0px;
		}

		.join-us-box h2 {
			font-weight: 500;
			font-size: 16px;
			font-family: MicrosoftYaHei;
			color: rgba(51, 51, 51, 1);
			margin-bottom: 10px;
		}

		.join-us-box h4 {
			font-size: 14px;
			line-height: 1.5;
			/* font-weight: 600; */
			margin-top: 10px;
		}

		.join-us-box p {
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(87, 90, 102, 1);
			line-height: 1.5;
			margin-bottom: 10px;
		}

		.join-us-box p.light {
			color: #848484;
			margin-bottom: 0;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/JoinUs.vue